module.exports = __webpack_public_path__ + "static/media/want-holders.1cb5d32d.svg";